import _toConsumableArray from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { Context } from './injectIntl';
import { formatMessage } from '../formatters/message';
import { invariantIntlContext, DEFAULT_INTL_CONFIG, createFormatters } from '../utils';
import * as shallowEquals_ from 'shallow-equal/objects';
var shallowEquals = shallowEquals_.default || shallowEquals_;

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }

  return formatMessage(Object.assign(Object.assign({}, DEFAULT_INTL_CONFIG), {
    locale: 'en'
  }), createFormatters(), descriptor, values);
};

var FormattedMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(FormattedMessage, _React$Component);

  var _super = _createSuper(FormattedMessage);

  function FormattedMessage() {
    _classCallCheck(this, FormattedMessage);

    return _super.apply(this, arguments);
  }

  _createClass(FormattedMessage, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _a = this.props,
          values = _a.values,
          otherProps = __rest(_a, ["values"]);

      var nextValues = nextProps.values,
          nextOtherProps = __rest(nextProps, ["values"]);

      return !shallowEquals(nextValues, values) || !shallowEquals(otherProps, nextOtherProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(Context.Consumer, null, function (intl) {
        if (!_this.props.defaultMessage) {
          invariantIntlContext(intl);
        }

        var _ref = intl || {},
            _ref$formatMessage = _ref.formatMessage,
            formatMessage = _ref$formatMessage === void 0 ? defaultFormatMessage : _ref$formatMessage,
            _ref$textComponent = _ref.textComponent,
            Text = _ref$textComponent === void 0 ? React.Fragment : _ref$textComponent;

        var _this$props = _this.props,
            id = _this$props.id,
            description = _this$props.description,
            defaultMessage = _this$props.defaultMessage,
            values = _this$props.values,
            children = _this$props.children,
            _this$props$tagName = _this$props.tagName,
            Component = _this$props$tagName === void 0 ? Text : _this$props$tagName;
        var descriptor = {
          id: id,
          description: description,
          defaultMessage: defaultMessage
        };
        var nodes = formatMessage(descriptor, values);

        if (!Array.isArray(nodes)) {
          nodes = [nodes];
        }

        if (typeof children === 'function') {
          return children.apply(void 0, _toConsumableArray(nodes));
        }

        if (Component) {
          // Needs to use `createElement()` instead of JSX, otherwise React will
          // warn about a missing `key` prop with rich-text message formatting.
          return React.createElement.apply(React, [Component, null].concat(_toConsumableArray(nodes)));
        }

        return nodes;
      });
    }
  }]);

  return FormattedMessage;
}(React.Component);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.defaultProps = {
  values: {}
};
export default FormattedMessage;